import PhotoSwipeLightbox from 'photoswipe/lightbox';
import { create } from 'zustand';

export const PRODUCT_PAGE_GALLERY_ID = 'product-gallery';

export type ProductPageGalleryStore = {
    photoSwipe: PhotoSwipeLightbox | null;
};

export const productPageGalleryStore = create<ProductPageGalleryStore>(() => ({
    photoSwipe: ProductPagePhotoSwipe(PRODUCT_PAGE_GALLERY_ID),
}));

function ProductPagePhotoSwipe(id: string) {
    return new PhotoSwipeLightbox({
        gallery: `#${id}`,
        mainClass: `pswp--${id}`,
        children: 'a',
        pswpModule: () => import('photoswipe'),
        zoom: false,
        counter: false,
        bgOpacity: 1,
        showHideAnimationType: 'fade',
        showAnimationDuration: 300,
        hideAnimationDuration: 300,
        arrowPrevSVG:
            '<svg aria-hidden="true" viewBox="0 0 16 16" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L6 8L10 4" stroke="currentColor" /></svg>',
        arrowNextSVG:
            '<svg aria-hidden="true" viewBox="0 0 16 16" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 4L10 8L6 12" stroke="currentColor" /></svg>',
        closeSVG:
            '<svg aria-hidden="true" viewBox="0 0 24 24" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6 18 18 M18 6 L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="square"></path></svg>',
    });
}
